<template>
  <v-ons-page modifier="white">
    <div class="header">
      <div class="user">
        <div class="picture" :style="{ backgroundImage: 'url(' + user_image + ')' }"></div>

        <div v-if="user" class="info">
          <p class="fullName">{{ user.pro_fName }} {{ user.pro_lName }}</p>
          <p class="address">{{ user.pro_city }}, {{ user_country }}</p>
      
          <div class="logout" @click="logout">
            <i class="fas fa-sign-out-alt"></i> {{ $t("Déconnexion") }}
          </div>
        </div>
      </div>
    </div>

    <v-ons-list>
      <v-ons-list-item v-if="user.project" @click="push('Project')" tappable><i class="fas fa-home"></i>{{ $t("Mon projet") }}</v-ons-list-item>
      <v-ons-list-item @click="push('Profile')" tappable><i class="fas fa-user"></i>{{ $t("Mon profil") }}</v-ons-list-item>
      <v-ons-list-item @click="push('Sponsorship')" tappable><i class="fas fa-gift"></i>{{ $t("Parrainage") }}</v-ons-list-item>
    </v-ons-list>

    <language-switcher></language-switcher>
  </v-ons-page>
</template>

<script>
import Login from './Login.vue';
import Profile from './Profile.vue';
import Project from './Project.vue';
import Sponsorship from './Sponsorship.vue';
import { EventBus } from '../EventBus.js';
import LanguageSwitcher from '../partials/LanguageSwitcher.vue';

export default {
  beforeCreate() {
    EventBus.$on('updateUserImage', (new_image) => {
      this.user_image = new_image;
    });
  },
  data() {
    return {
      Profile: Profile,
      Project: Project,
      Sponsorship: Sponsorship,
      user_image: profile_image,
      user: loggedIn
    };
  },
  methods: {
    logout() {
      localStorage.removeItem('loggedIn');
      EventBus.$emit('navigate', 'Login');
    },
    push(page) {
      EventBus.$emit('navigate', page);
    }
  },
  created() {
    axios
      .get('/users/get', {
        params: {
          'x-secundo-auth': loggedIn.token,
          'prospect_id': loggedIn.pro_id,
        }
      })
      .then(response => {
        this.user_image_directory = url_erp + '/customers/' + this.user.pro_id + '/profile_images/';

        if(this.user.pro_image_filename) {
          this.user_image = this.user_image_directory + this.user.pro_image_filename;
        }

        switch(this.user.pro_fk_language) {
          case '1':
          case '4':
            this.$i18n.locale = 'fr';
            break;
          case '3':
            this.$i18n.locale = 'nl';
            break;
        }
      });
  },
  computed: {
    user_country() {
      if(this.user.pro_fk_country) {
        var country_name_var = 'cty_name' + this.$i18n.locale.toUpperCase();
        return this.user[country_name_var];
      }

      return null;
    }
  },
  components: {
    LanguageSwitcher
  }
};
</script>

<style scoped>
.profile-pic {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #DDD;
  color: rgba(0, 0, 0, .56);
  padding-bottom: 8px;
}
.page--material .profile-pic {
  background-color: #f6f6f6;
}

.profile-pic > img {
  display: block;
  max-width: 100%;
}
.page--material__background.page--white__background {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// Menu.vue?f157f89e